module.exports = __webpack_public_path__ + "static/media/description.fa95a2e8.svg";